import styled from 'styled-components';

export const Image = styled.div`
  svg {
    display: block;
    margin: 0 auto;
    max-width: 70px;
  }
`;
